//!#system	

<template>
	<v-card>
		<v-card-title>
			<span class="headline">Download</span>
		</v-card-title>
		<v-progress-linear v-if="isLoading" indeterminate color="cyan"></v-progress-linear>
		<v-card-text>
			Download {{detail.fileName}}?
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn text @click="closeDialog()">Exit</v-btn>
			<v-btn color="primary" :disabled="!canSubmit" @click="doDownload()">Download file</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import apiService from '@/apiService';
export default {
	name: 'DataFileDownload',
	props: {
		routeInfo: {
			type: Object
		},
		detail: { // Optional starter object
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			isLoading: false
		}
	},
	computed: {
		canSubmit() {
			return !this.isLoading;
		}
	},
	methods: {
		closeDialog() {
			this.$emit('close');
			this.$emit('refresh');
		},
		b64toBlob(b64Data, contentType, sliceSize) {
			if (!sliceSize) sliceSize=512;
			const byteCharacters = atob(b64Data);
			const byteArrays = [];

			for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				const slice = byteCharacters.slice(offset, offset + sliceSize);

				const byteNumbers = new Array(slice.length);
				for (let i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				const byteArray = new Uint8Array(byteNumbers);
				byteArrays.push(byteArray);
			}

			const blob = new Blob(byteArrays, {type: contentType});
			return blob;
		},
		doDownload() {
			this.isLoading = true;
			apiService.action({ ...this.routeInfo, payload: {}, action: 'download' }, (err, response) => {
				this.isLoading = false;
				if (err) {
					return this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err 
					});
				}
				const fileName = this.detail.fileName;
				const element = document.createElement('a');
				if (this.detail.encoding === 'buffer') {
					let mime = 'application/application';
					if (fileName.endsWith('.pdf')) mime = 'application/pdf';
					const blob = this.b64toBlob(response.data, mime);
					const url = URL.createObjectURL(blob);
					element.setAttribute('href', url);
				} else {
					element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(response.data));
				}
				element.setAttribute('download', fileName);
				element.style.display = 'none';
				document.body.appendChild(element);
				element.click();
				document.body.removeChild(element);
				setTimeout(() => {
					try {
						URL.revokeObjectURL(element.href);
					} catch(err) {}
				}, 7000);
			});
		}
	}
}
</script>